/*
 * Horizontal-scroll layout for the Popular Products section.
 * Mirrors the product-page recommendations carousel (Swiper + prev/next arrows).
 * Swiper is loaded globally in layout/theme.liquid.
 */
(function () {
  if (typeof Swiper === "undefined") return;

  // Vertically center the prev/next arrows on the card image, matching the
  // product-recommendations carousel behaviour.
  const positionNav = (list) => {
    const nav = list.querySelector(".popular-products__slider-nav");
    const cardInner = list.querySelector(".card__inner");
    if (!nav || !cardInner) return;
    nav.style.top = cardInner.offsetHeight / 2 + "px";
  };

  const initList = (list) => {
    if (list.dataset.swiperInited === "true") return;
    list.dataset.swiperInited = "true";

    let mobileLayout = 1;
    if (list.dataset.mobileLayout) {
      mobileLayout = parseInt(list.dataset.mobileLayout, 10) || 1;
    }

    new Swiper(list, {
      slidesPerView: mobileLayout,
      slidesPerGroup: 1,
      spaceBetween: 8,
      speed: 1000,
      navigation: {
        nextEl: list.querySelector(
          ".popular-products__slider-nav .swiper-button-next"
        ),
        prevEl: list.querySelector(
          ".popular-products__slider-nav .swiper-button-prev"
        ),
      },
      breakpoints: {
        576: { slidesPerView: 2, slidesPerGroup: 2 },
        750: { slidesPerView: 3, slidesPerGroup: 3 },
        1200: { slidesPerView: 4, slidesPerGroup: 4 },
      },
    });

    positionNav(list);
    new ResizeObserver(() => positionNav(list)).observe(list);
  };

  const initAll = (root) => {
    (root || document)
      .querySelectorAll(".js-popular-products-swiper")
      .forEach((list) => initList(list));
  };

  initAll();

  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
